import React, {useCallback, useState, useEffect, useContext} from 'react';
import {RadioGroup, Radio, toast, Select, Input, Button, setOptions, Checkbox, Textarea} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {BottomNav, NavItem} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/microAppCalendar.css';
import Mobile from "../utils/Mobile";
import Loading from "../utils/Loading";
import {NetworkContext} from '../utils/NetworkContext';
import Empty from "../utils/Empty";
import dayjs from "dayjs";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function Calendar({locale, microApp, width}) {
    const {restCall, restResponse, setRestResponse} = useContext(NetworkContext);
    const [step, setStep] = useState(0);
    const [type, setType] = useState('mobile');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [notifications, setNotifications] = useState(true);
    const [country, setCountry] = useState(() => {
        if (window.localStorage.locale === 'en') {
            return 'us';
        } else if (window.localStorage.locale === 'es') {
            return 'mx';
        } else {
            return 'us';
        }
    });
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [paternalName, setPaternalName] = useState('');
    const [maternalName, setMaternalName] = useState('');
    const [dob, setDob] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [year, setYear] = useState('');
    const [gender, setGender] = useState('male');
    const [auth, setAuth] = useState(false);
    const [putPatient, setPutPatient] = useState(true);
    const [firstVisit, setFirstVisit] = useState(true);
    const [reason, setReason] = useState('');

    const ButtonNext = () => {
        if (step === 3 && microApp.patients.longName && (!firstName || !paternalName)) {
            toast({message: locale.microAppCalendar.s, color: 'danger', display: 'top', duration: 3000});
        } else if (step === 3 && !microApp.patients.longName && (!firstName || !lastName)) {
            toast({message: locale.microAppCalendar.s, color: 'danger', display: 'top', duration: 3000});
        } else if (step === 4 && (!month || !day || !year)) {
            toast({message: locale.microAppCalendar.ac, color: 'danger', display: 'top', duration: 3000});
        } else {
            if (step === 4) {
                const date = year + '-' + month + '-' + day;
                setDob(date);
            }

            const item = step + 1;
            setStep(item);
        }
    }

    const ButtonCheck = () => {
        if (type === 'mobile' && !mobile) {
            toast({message: locale.microAppCalendar.k, color: 'danger', display: 'top', duration: 3000});
        } else if (type === 'whatsapp' && !mobile) {
            toast({message: locale.microAppCalendar.ao, color: 'danger', display: 'top', duration: 3000});
        } else if (type === 'email' && !email) {
            toast({message: locale.microAppCalendar.l, color: 'danger', display: 'top', duration: 3000});
        } else {
            setStep(9);

            let number = '';
            if (type === 'mobile' || type === 'whatsapp') {
                number = mobile.replace(/[()\s-]/g, '');
            }

            const message = {
                type: 'rest',
                path: 'calendar-patient',
                action: 'get',
                data: {
                    email: type === 'email' ? email : null,
                    mobile: (type === 'mobile' || type === 'whatsapp') ? number : null,
                    country: (type === 'mobile' || type === 'whatsapp') ? country : null,
                    type: type,
                    microApp: {
                        account: microApp.account
                    }
                }
            };
            restCall(message);
        }
    }

    const ButtonLogin = () => {
        if (!password) {
            toast({message: locale.microAppCalendar.aw, color: 'danger', display: 'top', duration: 3000});
        } else {
            setStep(9);

            let number = '';
            if (type === 'mobile' || type === 'whatsapp') {
                number = mobile.replace(/[()\s-]/g, '');
            }

            const message = {
                type: 'rest',
                path: 'calendar-password',
                action: 'get',
                data: {
                    email: type === 'email' ? email : null,
                    mobile: (type === 'mobile' || type === 'whatsapp') ? number : null,
                    country: (type === 'mobile' || type === 'whatsapp') ? country : null,
                    type: type,
                    microApp: {
                        account: microApp.account
                    },
                    password: password
                }
            };
            restCall(message);
        }
    }

    const ButtonReview = () => {
        setStep(8);
    }

    const ButtonFinish = () => {
        setType('mobile');
        setEmail('');
        setMobile('');
        setPassword('');
        setNotifications(true);
        setFirstName('');
        setMiddleName('');
        setLastName('');
        setPaternalName('');
        setMaternalName('');
        setDob('');
        setMonth('');
        setDay('');
        setYear('');
        setGender('');
        setAuth(false);
        setPutPatient(true);
        setReason('');
        setStep(0);
    }

    const ButtonSchedule = () => {
        if (!reason) {
            toast({message: locale.microAppCalendar.ai, color: 'danger', display: 'top', duration: 3000});
        } else {
            setStep(9);

            let number = '';
            if (type === 'mobile' || type === 'whatsapp') {
                number = mobile.replace(/[()\s-]/g, '');
            }

            const message = {
                type: 'rest',
                path: 'calendar',
                action: 'put',
                data: {
                    email: type === 'email' ? email : null,
                    mobile: (type === 'mobile' || type === 'whatsapp') ? number : null,
                    country: (type === 'mobile' || type === 'whatsapp') ? country : null,
                    firstName: firstName ? firstName : null,
                    middleName: middleName ? middleName : null,
                    lastName: lastName ? lastName : null,
                    paternalName: paternalName ? paternalName : null,
                    maternalName: maternalName ? maternalName : null,
                    dob: dob,
                    gender: gender,
                    notifications: notifications,
                    reason: reason,
                    type: type,
                    new: putPatient,
                    locale: window.localStorage.locale,
                    firstVisit: firstVisit,
                    microApp: {
                        account: microApp.account,
                        location: microApp.location,
                        options: microApp.options,
                        patients: microApp.patients,
                        start: microApp.start,
                        end: microApp.end,
                        resource: microApp.resource,
                        event: microApp.event,
                        code: microApp.code
                    }
                }
            };
            restCall(message);
        }
    }

    const ButtonBack = () => {
        if (step === 8) {
            setStep(6);
        } else if (step === 3) {
            setStep(1);
        } else {
            const item = step - 1;
            setStep(item);
        }
    }

    const InputMonth = data => {
        if (data.length < month.length) {
            setMonth(data);
            return;
        }

        const numericValue = data.replace(/[^\d]/g, '');
        let truncatedValue = numericValue.slice(0, 2);

        let monthNumber = parseInt(truncatedValue, 10);
        if (monthNumber > 12) {
            truncatedValue = '12';
        }

        setMonth(truncatedValue);
    };

    const InputDay = data => {
        if (data.length < dob.length) {
            setDay(data);
            return;
        }

        const numericValue = data.replace(/[^\d]/g, '');
        let truncatedValue = numericValue.slice(0, 2);

        let dayNumber = parseInt(truncatedValue, 10);
        if (dayNumber > 31) {
            truncatedValue = '31';
        }

        setDay(truncatedValue);
    };

    const InputYear = data => {
        if (data.length < dob.length) {
            setYear(data);
            return;
        }

        const numericValue = data.replace(/[^\d]/g, '');
        let truncatedValue = numericValue.slice(0, 4);

        let yearNumber = parseInt(truncatedValue, 10);
        if (yearNumber > dayjs().year()) {
            truncatedValue = dayjs().year().toString();
        }

        setYear(truncatedValue);
    };

    const RadioType = data => {
        setType(data.target.value);
    }

    const RadioGender = data => {
        setGender(data.target.value);
    }

    const PutCalendar = useCallback(data => {
        if (data.toast) {
            setStep(7);
        }
    }, []);

    const GetCalendarPatient = useCallback(data => {
        if (data.firstVisit === true || data.firstVisit === false) {
            setFirstVisit(data.firstVisit);
        }
        if (data.login === true) {
            setStep(2);
            setPutPatient(false);
        } else if (data.login === false) {
            setStep(3);
        }
    }, []);

    const GetCalendarPassword = useCallback(data => {
        if (data.user) {
            setFirstName(data.user.firstName);
            setMiddleName(data.user.middleName);
            setLastName(data.user.lastName);
            setPaternalName(data.user.paternalName);
            setMaternalName(data.user.maternalName);
            setDob(data.user.dob);
            setGender(data.user.gender);
            setAuth(true);

            setStep(6);
        }
        if (data.error) {
            toast({message: locale.microAppCalendar.ax, color: 'danger', display: 'top', duration: 3000});
            setStep(2);
        }
    }, [locale.microAppCalendar.ax]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'calendar-password') {
            GetCalendarPassword(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetCalendarPassword, setRestResponse]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'calendar-patient') {
            GetCalendarPatient(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetCalendarPatient, setRestResponse]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'put' && restResponse.path === 'calendar') {
            PutCalendar(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, PutCalendar, setRestResponse]);

    return (
        <div className={width > 768 ? "mbsc-grid cs-microapp-calendar-main" : "mbsc-grid cs-microapp-calendar-main-small"} >
            <div className="mbsc-row mbsc-justify-content-center">
                <div className="mbsc-col-sm-12 mbsc-col-md-11 mbsc-col-xl-10 cs-microapp-calendar-page" >
                    {step === 0 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.be} {dayjs(microApp.start).format("MMM D YYYY")} {locale.microAppCalendar.au} {dayjs(microApp.start).format("h:mm a")} - {dayjs(microApp.end).format("h:mm a")}.</h3>
                                <h3>{locale.microAppCalendar.d}</h3>
                            </div>
                            <RadioGroup name="type" >
                                <Radio className={type === 'mobile' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.b} value="mobile" checked={type === 'mobile'} onChange={RadioType} defaultChecked={true} />
                                {microApp.options.whatsapp &&
                                    <Radio className={type === 'whatsapp' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.am} value="whatsapp" checked={type === 'whatsapp'} onChange={RadioType} />
                                }
                                <Radio className={type === 'email' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.c} value="email" checked={type === 'email'} onChange={RadioType} />
                            </RadioGroup>
                        </>
                    }
                    {step === 1 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                {type === 'mobile' &&
                                    <h3>{locale.microAppCalendar.g}</h3>
                                }
                                {type === 'whatsapp' &&
                                    <h3>{locale.microAppCalendar.an}</h3>
                                }
                                {type === 'email' &&
                                    <h3>{locale.microAppCalendar.j}</h3>
                                }
                            </div>
                            {(type === 'mobile' || type === 'whatsapp') && width > 576 &&
                                <div className="mbsc-grid cs-microapp-calendar-grid">
                                    <div className="mbsc-row">
                                        <div className="mbsc-col-4 cs-microapp-calendar-inputs-left">
                                            <Select
                                                label={locale.microAppCalendar.e}
                                                rows={2}
                                                display="inline"
                                                touchUi={true}
                                                value={country}
                                                data={locale.microAppCalendar.f}
                                                disabled={mobile.length !== 0}
                                                onChange={args => setCountry(args.value)}
                                            />
                                        </div>
                                        <div className="mbsc-col-8 cs-microapp-calendar-inputs-right">
                                            <Input className="cs-microapp-calendar-inputs-right-input mbsc-txt-l" label={locale.microAppCalendar.b} inputStyle="underline" labelStyle="floating" type="text" name="mobile" value={mobile} onChange={ev => Mobile({data: ev.target.value, setMobile: setMobile, country: country})} />
                                        </div>
                                    </div>
                                </div>
                            }
                            {(type === 'mobile' || type === 'whatsapp') && width < 576 &&
                                <>
                                    <Select
                                        label={locale.microAppCalendar.e}
                                        rows={locale.microAppCalendar.f.length}
                                        display="inline"
                                        touchUi={true}
                                        value={country}
                                        data={locale.microAppCalendar.f}
                                        disabled={mobile.length !== 0}
                                        onChange={args => setCountry(args.value)}
                                    />
                                    <Input className="cs-microapp-calendar-inputs-right-input mbsc-txt-l" label={locale.microAppCalendar.b} inputStyle="underline" labelStyle="floating" type="text" name="mobile" value={mobile} onChange={ev => Mobile({data: ev.target.value, setMobile: setMobile, country: country})} />
                                </>
                            }
                            {type === 'email' &&
                                <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.c} labelStyle="floating" type="email" name="email" value={email} onChange={ev => setEmail(ev.target.value)} />
                            }
                            {type === 'whatsapp' &&
                                <Checkbox
                                    className="mbsc-txt-l mbsc-txt-muted"
                                    color="info"
                                    label={locale.microAppCalendar.aj}
                                    checked={notifications}
                                    onChange={(ev) => setNotifications(ev.target.checked)}
                                />
                            }
                            {type === 'mobile' &&
                                <Checkbox
                                    className="mbsc-txt-l mbsc-txt-muted"
                                    color="info"
                                    label={locale.microAppCalendar.ak}
                                    checked={notifications}
                                    onChange={(ev) => setNotifications(ev.target.checked)}
                                />
                            }
                            {type === 'email' &&
                                <Checkbox
                                    className="mbsc-txt-l mbsc-txt-muted"
                                    color="info"
                                    label={locale.microAppCalendar.al}
                                    checked={notifications}
                                    onChange={(ev) => setNotifications(ev.target.checked)}
                                />
                            }
                        </>
                    }
                    {step === 2 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.at}</h3>
                            </div>
                            <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.as} labelStyle="floating" type="password" passwordToggle={true} name="password" value={password} onChange={ev => setPassword(ev.target.value)} />
                            <div className="cs-microapp-calendar-helper-link mbsc-align-right" >
                                <h3 className="mbsc-bold" onClick={() => ButtonNext()} >{locale.microAppCalendar.ar}</h3>
                            </div>
                        </>
                    }
                    {step === 3 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.r}</h3>
                            </div>
                            {microApp.patients.longName ?
                                <>
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.o} labelStyle="floating" type="text" name="firstName" value={firstName} onChange={ev => setFirstName(ev.target.value)} />
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.q} labelStyle="floating" type="text" name="middleName" value={middleName} onChange={ev => setMiddleName(ev.target.value)} />
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.n} labelStyle="floating" type="text" name="paternalName" value={paternalName} onChange={ev => setPaternalName(ev.target.value)} />
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.m} labelStyle="floating" type="text" name="maternalName" value={maternalName} onChange={ev => setMaternalName(ev.target.value)} />
                                </>
                                :
                                <>
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.o} labelStyle="floating" type="text" name="name" value={firstName} onChange={ev => setFirstName(ev.target.value)} />
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.p} labelStyle="floating" type="text" name="name" value={lastName} onChange={ev => setLastName(ev.target.value)} />
                                </>
                            }
                        </>
                    }
                    {step === 4 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.t}</h3>
                            </div>
                            <div className="mbsc-row cs-microapp-calendar-section">
                                <div className="mbsc-col mbsc-align-center">
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" placeholder={locale.microAppCalendar.z} label={locale.microAppCalendar.w} labelStyle="floating" type="text" name="month" value={month} onChange={ev => InputMonth(ev.target.value)} />
                                </div>
                                <div className="mbsc-col mbsc-align-center">
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" placeholder={locale.microAppCalendar.aa} label={locale.microAppCalendar.x} labelStyle="floating" type="text" name="day" value={day} onChange={ev => InputDay(ev.target.value)} />
                                </div>
                                <div className="mbsc-col mbsc-align-center">
                                    <Input className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" placeholder={locale.microAppCalendar.ab} label={locale.microAppCalendar.y} labelStyle="floating" type="text" name="year" value={year} onChange={ev => InputYear(ev.target.value)} />
                                </div>
                            </div>
                        </>
                    }
                    {step === 5 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.u}</h3>
                            </div>
                            <RadioGroup name="gender" >
                                <Radio className={gender === 'male' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.v} value="male" checked={gender === 'male'} onChange={RadioGender} defaultChecked={true} />
                                <Radio className={gender === 'female' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.ad} value="female" checked={gender === 'female'} onChange={RadioGender} />
                                <Radio className={gender === 'n/a' ? 'mbsc-bold mbsc-txt-m' : 'mbsc-txt-m'} label={locale.microAppCalendar.ae} value="n/a" checked={gender === 'n/a'} onChange={RadioGender} />
                            </RadioGroup>
                        </>
                    }
                    {step === 6 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{auth ? locale.microAppCalendar.ay : locale.microAppCalendar.af}</h3>
                            </div>
                            <div className="cs-microapp-calendar-textarea">
                                <Textarea className="mbsc-txt-l" inputStyle="underline" labelStyle="floating" placeholder={locale.microAppCalendar.ah} value={reason} onChange={(ev) => setReason(ev.target.value)} />
                            </div>
                            {auth &&
                                <div className="cs-microapp-calendar-helper-link mbsc-align-right" >
                                    <h3 className="mbsc-bold" onClick={() => ButtonReview()} >{locale.microAppCalendar.az}</h3>
                                </div>
                            }
                        </>
                    }
                    {step === 7 &&
                        <div className="cs-microapp-calendar-helper mbsc-align-center" >
                            <h3>{locale.microAppCalendar.ap}</h3>
                        </div>
                    }
                    {step === 8 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.ba}</h3>
                            </div>
                            {microApp.patients.longName ?
                                <>
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.o} labelStyle="floating" type="text" name="firstName" value={firstName} />
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.q} labelStyle="floating" type="text" name="middleName" value={middleName} />
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.n} labelStyle="floating" type="text" name="paternalName" value={paternalName} />
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.m} labelStyle="floating" type="text" name="maternalName" value={maternalName} />
                                </>
                                :
                                <>
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.o} labelStyle="floating" type="text" name="name" value={firstName} />
                                    <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.p} labelStyle="floating" type="text" name="name" value={lastName} />
                                </>
                            }
                            <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.bb} labelStyle="floating" type="text" name="dob" value={window.localStorage.locale === 'en' ? dayjs(dob).format("M/D/YYYY") : dayjs(dob).format("D/M/YYYY")} />
                            <Input disabled className="cs-microapp-calendar-input mbsc-txt-l" inputStyle="underline" label={locale.microAppCalendar.bc} labelStyle="floating" type="text" name="gender" value={gender === 'n/a' ? locale.microAppCalendar.ae : gender.charAt(0).toUpperCase() + gender.slice(1)} />
                        </>
                    }
                    {step === 9 &&
                        <>
                            <div className="cs-microapp-calendar-helper mbsc-align-center" >
                                <h3>{locale.microAppCalendar.bf}</h3>
                            </div>
                            <div className="cs-microapp-calendar-loading mbsc-align-center" >
                                <Loading />
                            </div>
                        </>
                    }
                </div>
            </div>
            <div className="cs-microapp-calendar-nav-bottom" >
                <BottomNav
                    theme="ios"
                    themeVariant="light"
                    type="bottom"
                >
                    {(step === 1 || step === 2 || step === 3 || step === 4 || step === 5 || step === 6 || (step === 8 && auth)) &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonBack()} >
                                {(step === 8 && auth) ? locale.microAppCalendar.bd : locale.microAppCalendar.i}
                            </Button>
                        </NavItem>
                    }
                    {step === 0 &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonNext()} >
                                {locale.microAppCalendar.a}
                            </Button>
                        </NavItem>
                    }
                    {step === 1 &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonCheck()} >
                                {locale.microAppCalendar.h}
                            </Button>
                        </NavItem>
                    }
                    {(step === 3 || step === 4 || step === 5) &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonNext()} >
                                {locale.microAppCalendar.h}
                            </Button>
                        </NavItem>
                    }
                    {step === 2 &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonLogin()} >
                                {locale.microAppCalendar.av}
                            </Button>
                        </NavItem>
                    }
                    {step === 6 &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonSchedule()} >
                                {locale.microAppCalendar.ag}
                            </Button>
                        </NavItem>
                    }
                    {step === 7 && auth &&
                        <NavItem>
                            <Button color="primary" className={width > 768 ? "cs-microapp-calendar-button-bottom mbsc-txt-xl mbsc-bold" : "cs-microapp-calendar-button-bottom mbsc-txt-l mbsc-bold"} onClick={() => ButtonFinish()} >
                                {locale.microAppCalendar.aq}
                            </Button>
                        </NavItem>
                    }
                </BottomNav>
            </div>
        </div>
    );
}

export default Calendar;
